import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { SecurityProfileService } from 'app/services/securityProfile.service';
import { UserService } from 'app/services/user.service';
import { ROLES, User } from 'shared-models';

@Component({
  selector: 'user',
  templateUrl: './user.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: 'user',
  imports: [MatButtonModule, MatMenuModule, MatIconModule, NgClass, MatDividerModule],
})
export class UserComponent implements OnInit {
  user: User | null = null;
  role!: ROLES;
  ROLES = ROLES;

  /**
   * Constructor
   */
  constructor(
    private _router: Router,
    private authService: AuthService,
    private userService: UserService,
    private securityProfileService: SecurityProfileService
  ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.user = this.userService.getUser();
    this.role = this.securityProfileService.getRole() ?? ROLES.USER;
  }
  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Navigate to profile
   */
  goToProfile(): void {
    this._router.navigate(['/profile']);
  }

  /**
   * Navigate to the payments
   */
  payments(): void {
    this._router.navigate(['/admin/payments']);
  }

  /**
   * Sign out
   */
  signOut(): void {
    this.authService.logOut();
    this._router.navigate(['/sign-in']);
  }
}
